import { useCallback, useState } from "react";

import User from "byzantine/src/User";
import { useObjectMemo } from "byzantine";

import { useCurrentUser } from "../../../components/contexts/CurrentUserContext";

export const useIncomeReportingCard = () => {
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false);
  const { currentUser, setCurrentUser } = useCurrentUser();
  const { income_sources: incomeSources = [] } = currentUser || {};
  // Only displaying and editing a single IncomeSource at this time
  const incomeSource = incomeSources[0];

  const openFormHandler = () => {
    setIsFormOpen(true);
  };

  const dismissFormHandler = () => {
    setIsFormOpen(false);
  };

  const updateIncomeSources = useCallback(
    (updatedIncomeSource: API.IncomeSource) => {
      if (currentUser) {
        setCurrentUser(
          new User({ ...currentUser, income_sources: [updatedIncomeSource] })
        );
      }
    },
    [currentUser, setCurrentUser]
  );

  return useObjectMemo({
    incomeSource,
    isFormOpen,
    openFormHandler,
    dismissFormHandler,
    updateIncomeSources,
  });
};
